/**
 * Public URL of a Storage object. Objects under uploads/ are world-readable (see storage.rules), so
 * no download token is needed and URLs can be derived from paths on any client.
 */
export function storagePathToUrl(
  bucket: string,
  path: string,
  emulatorHost?: string | null,
): string {
  const base = emulatorHost ? `http://${emulatorHost}` : 'https://firebasestorage.googleapis.com';
  return `${base}/v0/b/${bucket}/o/${encodeURIComponent(path)}?alt=media`;
}
